import { SaveDataKeys } from '../SaveDataKeys';
import { CoreController } from '../../CoreController';

export class StoryProgressManager {
    private static _instance: StoryProgressManager;
    private managerClass: any;
    public numberOfSessions: number;

    public async init(managerClass: any): Promise<void> {
        this.managerClass = managerClass;
        const currentChapter: number = CoreController.getInstance().getCurrentChapter();

        await this.retreiveNumberOfSessions().then((data: any) => {
            if (data && data.numberOfSessions !== undefined) {
                this.numberOfSessions = data.numberOfSessions;
            } else {
                this.numberOfSessions = 0;
            }
            this.numberOfSessions++;
            console.log('saved number of sessions: ' + this.numberOfSessions);
            this.saveNumberOfSessions();
        });
    }

    public static getInstance(): StoryProgressManager {
        return this._instance || (this._instance = new this());
    }

    public saveLevelsInSession(value: number): void {
        this.managerClass.getInstance().saveData(SaveDataKeys.levelsInSession, value);
    }

    public saveNumberOfSessions(): void {
        this.managerClass.getInstance().saveData(SaveDataKeys.numberOfSessions, this.numberOfSessions);
    }

    public saveSessionDuration(value: number): void {
        this.managerClass.getInstance().saveData(SaveDataKeys.sessionDuration, value);
    }

    public async retreiveStoryTime(): Promise<number> {
        return this.managerClass.getInstance().retreiveStoryTime();
    }

    public async retreiveNumberOfSessions(): Promise<number> {
        return this.managerClass.getInstance().retreiveNumberOfSessions();
    }

    public async getType(): Promise<number[]> {
        return FBInstant.player
            .getDataAsync([SaveDataKeys.type]);
    }

    public async getNumberOfSessions(): Promise<number> {
        if (!this.numberOfSessions) {
            await this.retreiveNumberOfSessions();
        }
        return this.numberOfSessions;
    }
}